var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-button',{staticClass:"md-button w-100 pt-3 pb-3",class:_vm.buttonClass,attrs:{"disabled":""}},[_c('span',{class:_vm.iconClass,attrs:{"role":"status","aria-hidden":"true"}}),_vm._v("\n  "+_vm._s(_vm.$t(_vm.text))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }